import { THighlightedMessage, } from '@Hooks';
import { TypeConversationMessage, } from 'atlas-shared/dist';

export const highlightClassNames = (message: TypeConversationMessage, highlightedMessage: THighlightedMessage) => `${highlightedMessage[0]?.channel === message.channel && highlightedMessage[0]?.id === message.id ? ' highlighted' : ''}${highlightedMessage[2]?.channel === message.channel && highlightedMessage[2]?.id === message.id ? ' click-highlighted' : ''}`;
